function Mark() {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      aria-hidden="true"
      className="mb-4"
    >
      <rect width="72" height="72" rx="16" fill="#0c0e14" />
      <path
        d="M44 16.5c-8.6 2.2-14.8 10-14.8 19.3 0 9.2 6.1 17 14.6 19.3-2.3.6-4.7.9-7.2.9-12.4 0-22.4-10-22.4-22.4S24.2 11.2 36.6 11.2c2.6 0 5 .4 7.4 1.3z"
        fill="#e8a23a"
      />
      <path d="M46 38c7 2.2 12 2.2 18 0" stroke="#e8a23a" strokeWidth="1.8" fill="none" strokeLinecap="round" />
      <path d="M49 45c6 1.8 10 1.8 15 0" stroke="#e8a23a" strokeWidth="1.8" fill="none" strokeLinecap="round" opacity="0.62" />
      <path d="M52 51c5 1.4 8 1.4 12 0" stroke="#e8a23a" strokeWidth="1.8" fill="none" strokeLinecap="round" opacity="0.32" />
    </svg>
  );
}

export default Mark;
